(function () {
  const PEEK_REPEAT_COUNT = 3;
  const PEEK_DURATION_MS = 450;
  const PEEK_PAUSE_MS = 350;
  let peekAnimationPlayed = false;

  function shouldRunPeekAnimation(container, slideCount) {
    return container.dataset.peekAnimation === 'true' && slideCount > 1 && !peekAnimationPlayed;
  }

  function runPeekAnimation(swiper) {
    if (!swiper || swiper.destroyed || swiper.slides.length < 2) return;

    let completedCycles = 0;
    swiper.allowTouchMove = false;

    const runCycle = () => {
      if (completedCycles >= PEEK_REPEAT_COUNT || swiper.destroyed) {
        swiper.allowTouchMove = true;
        return;
      }

      const peekDistance = swiper.slides[0].offsetWidth * 0.5;

      swiper.setTransition(PEEK_DURATION_MS);
      swiper.setTranslate(-peekDistance);

      window.setTimeout(() => {
        if (swiper.destroyed) return;

        swiper.setTransition(PEEK_DURATION_MS);
        swiper.setTranslate(0);

        window.setTimeout(() => {
          completedCycles += 1;
          runCycle();
        }, PEEK_DURATION_MS + PEEK_PAUSE_MS);
      }, PEEK_DURATION_MS + PEEK_PAUSE_MS);
    };

    runCycle();
  }

  function updateArrowState(swiper, prevButton, nextButton) {
    if (!prevButton || !nextButton) return;

    prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
    nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
    prevButton.toggleAttribute('disabled', swiper.isBeginning);
    nextButton.toggleAttribute('disabled', swiper.isEnd);
  }

  function bindSliderControlEvents(container, swiper) {
    const prevButton = container.querySelector('.collection-product-slider__arrow--prev');
    const nextButton = container.querySelector('.collection-product-slider__arrow--next');
    const pagination = container.querySelector('.collection-product-slider__pagination');

    updateArrowState(swiper, prevButton, nextButton);

    swiper.on('slideChange', () => {
      updateArrowState(swiper, prevButton, nextButton);
    });

    prevButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (swiper.destroyed || swiper.isBeginning) return;
      swiper.slidePrev();
    });

    nextButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (swiper.destroyed || swiper.isEnd) return;
      swiper.slideNext();
    });

    pagination?.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }

  function initSlider(container) {
    if (!container || container.dataset.sliderInitialized === 'true') return;

    const swiperElement = container.querySelector('.collection-product-slider__swiper');
    if (!swiperElement || typeof Swiper === 'undefined') return;

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    const shouldPeek = shouldRunPeekAnimation(container, slideCount);

    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      resistanceRatio: 0,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    container.dataset.sliderInitialized = 'true';
    container.swiperInstance = swiper;

    bindSliderControlEvents(container, swiper);

    if (shouldPeek) {
      peekAnimationPlayed = true;
      window.requestAnimationFrame(() => {
        runPeekAnimation(swiper);
      });
    }
  }

  function destroySlider(container) {
    if (!container?.swiperInstance) return;

    container.swiperInstance.destroy(true, true);
    delete container.swiperInstance;
    container.dataset.sliderInitialized = 'false';
  }

  function initAllSliders(root = document) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-collection-product-slider]').forEach((container) => {
      initSlider(container);
    });
  }

  function reinitSliders(root = document) {
    root.querySelectorAll('[data-collection-product-slider]').forEach((container) => {
      destroySlider(container);
      initSlider(container);
    });
  }

  window.initCollectionProductSliders = initAllSliders;
  window.reinitCollectionProductSliders = reinitSliders;

  function onReady() {
    initAllSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('load', () => {
    initAllSliders();
  });
})();
